import * as z from 'zod';
import { hearingHealthPartnersSalesforceValues } from '@/components/user-details/constants/hearing-health-partners.constant';
import { createEventSchema } from 'hx-analytics';
export var lexieCustomEventSchemas = {
    health_and_member_discounts: createEventSchema({
        data: z.enum(hearingHealthPartnersSalesforceValues).array(),
    }, 'heardigits_widget_health_and_member_discounts'),
    test_start: createEventSchema({
        attribution: z.record(z.unknown()),
    }, 'heardigits_widget_test_start'),
    birth_year: createEventSchema({ value: z.string() }, 'heardigits_widget_event'),
    under_age: createEventSchema({ value: z.string() }, 'heardigits_widget_event'),
};
